import { render, staticRenderFns } from "./classesRedirect.vue?vue&type=template&id=4531be4d&"
import script from "./classesRedirect.vue?vue&type=script&lang=js&"
export * from "./classesRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports